/* eslint jsx-a11y/anchor-is-valid: 0 */

import { history } from '../../state/store';
import React from 'react';
import './OrganizationStatusPage.scss';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import _ from 'lodash';

// This is one table, the criteria is for just this table.
class CheckinTable extends React.Component {
    constructor(props) {
        super(props);

        const practices = Object.keys(props.practices).map((p, i) => {
            return props.practices[p];
        });

        this.state = {
            columns: this.formatData(practices),
            filteredRegions: [],
            regionList: [],
            rows: props.criteria,
            count: props.criteria.length,
        };
    }

    compareValues = (key, sortOrder = 'asc') => {
        return function (a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                console.error(
                    `Error: Could not sort items by the key "${key}" because it does not exist on either object being compared.`
                );
                return 0;
            }

            const varA =
                typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
            const varB =
                typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }

            const result = sortOrder === 'desc' ? comparison * -1 : comparison;

            return result;
        };
    };

    checkSubmitStatus = (row, practices, key) => {
        const id = practices[key].id;

        // Get the status from the row, or return an empty string.
        // Convert to lower case.
        const status = _.get(row, `practice_${id}.status`, '').toLowerCase();

        if (status) {
            if (
              status === 'prevalidated' ||
              status === 'q-submit' ||
              status === 'q-ready'
            ) {
              return true;
            }
        }

        return false;
    };

    formatData = (practices) => {
        let columns = [];
        columns.push({
            Header: 'Criteria',
            accessor: 'description',
            maxWidth: 600,
            minWidth: 400,
            className: 'sticky',
            headerClassName: 'sticky',
        });

        Object.keys(practices).forEach((key) => {
            columns.push({
                id: `practice_${practices[key].id}`,
                Header: (props) =>
                    practices[key].primary_practice ? (
                        <div>
                            <i className="fa fa-hospital-o" />{' '}
                            {practices[key].abbreviation}
                        </div>
                    ) : (
                        `${practices[key].abbreviation}`
                    ),
                accessor: `practices.${practices[key].id}`,
                minWidth: 80,
                sortable: false,
                Cell: ({ row }) => {
                    if (this.checkSubmitStatus(row, practices, key)) {
                        return (
                            <a
                                onClick={() => {
                                    history.push(
                                        `/criterion/${
                                            row[`practice_${practices[key].id}`]
                                                .id
                                        }`
                                    );
                                }}
                                className="complete">
                                <i className="fa fa-check-circle" />
                            </a>
                        );
                    } else if (
                        _.get(row, `practice_${practices[key].id}.status`) ===
                        'Q-Met'
                    ) {
                        return (
                            <a
                                onClick={() => {
                                    history.push(
                                        `/criterion/${
                                            row[`practice_${practices[key].id}`]
                                                .id
                                        }`
                                    );
                                }}
                                className="complete">
                                <i className="fa fa-check-square-o" />
                            </a>
                        );
                    } else if (
                        _.get(row, `practice_${practices[key].id}.status`) ===
                        'Disabled'
                    ) {
                        return <a className="Disabled"> </a>;
                    } else {
                        let rowInfo = row[`practice_${practices[key].id}`];
                        if (rowInfo) {
                            let id = rowInfo.id;
                            let link = `/criterion/${id}`;
                            if (id && link) {
                                return (
                                    <a
                                        onClick={() => {
                                            history.push(link);
                                        }}
                                        className={`${_.get(
                                            row,
                                            `practice_${practices[key].id}.criticality`
                                        )}`}>
                                        &nbsp;
                                    </a>
                                );
                            } else {
                                return <a className="Disabled"> </a>;
                            }
                        } else {
                            return <a className="Disabled"> </a>;
                        }
                    }
                },
            });
        });

        return columns;
    };

    // used to set min/max on widths and adjust based on overlap text automatically. *** comes with performance hit...

    render() {
        return (
            <div className="CheckinTable">
                <div className="CheckinHeader">
                    <h3>{this.props.label}</h3>
                </div>
                <div className="StatusWrapper">
                    <ReactTable
                        data={this.state.rows}
                        columns={this.state.columns}
                        className="-striped -highlight"
                        style={{ height: '600px' }}
                        showPagination={false}
                        defaultPageSize={this.state.count}
                    />
                </div>
            </div>
        );
    }
}
export default CheckinTable;
